import { pickThemeColor, pickThemeFontStyles } from '@/theme';
import styled from 'styled-components';

export const StyledCard = styled.article`
  padding: 1rem;
  background-color: ${pickThemeColor('BG_SECONDARY')};
  border: 1px solid ${pickThemeColor('LIGHT_PURPLE')};
  border-radius: 0.25rem;
  flex-direction: column;
  display: flex;
  gap: 1rem;
`;

export const StyledName = styled.h2`
  ${pickThemeFontStyles('16', '26', 'BOLD')};
  color: ${pickThemeColor('BLACK_PRIMARY')};
  margin: 0;
`;

export const StyledWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const StyledTitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const StyledButtonsWrapper = styled.div`
  flex-wrap: nowrap;
  display: flex;
`;

export const StyledLabel = styled.div`
  ${pickThemeFontStyles('14', '20', 'NORMAL')};
  color: ${pickThemeColor('GREY')};
  white-space: nowrap;
`;

export const StyledValue = styled.div`
  ${pickThemeFontStyles('16', '26', 'NORMAL')};
  color: ${pickThemeColor('BLACK_PRIMARY')};

  ul {
    list-style: none;
    padding-left: 1.5rem;
    li::before {
      content: '✔';
      color: black;
      font-weight: bold;
      display: inline-block;
      width: 1rem;
      margin-left: -1.5rem;
      margin-right: 0.5rem;
    }
  }
`;

export const StyledItem = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledContent = styled.div`
  display: flex;
  gap: 3rem;
  flex: 1;
  width: 100%;
`;

export const StyledContentWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;

  > div {
    width: 50%;
  }
`;
